import { useContext } from "react";
import { defaultExplorerConfig, ExplorerContext } from "../context/explorer-context";
export var useExplorer = function () {
  return useContext(ExplorerContext) || defaultExplorerConfig;
};